import MentorGroupList from "../groups/list/MentorGroupList"

function GroupAugmentation() {
  return <MentorGroupList />
}

export default GroupAugmentation
